function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#1D998C",
  strokeWidth: 4,
  d: "M13.209 12.289l17.118 9.875V2h20.609v20.164l17.612-9.875L79 29.311 61.317 40.13 79 50.529 68.548 67.765 50.936 58.91V78H30.327V58.91l-17.118 8.855L3 50.529 19.831 40.13 3 29.311z"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#1D998C",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M38.718 63.749V24.855a1.093 1.093 0 112.187 0V63.75H38.718z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M39.812 25.955a4.028 4.028 0 01-3.72-2.486 4.023 4.023 0 015.259-5.258 4.028 4.028 0 012.486 3.719 4.028 4.028 0 01-4.025 4.025zm0-5.863a1.838 1.838 0 101.837 1.838c0-1.015-.823-1.84-1.837-1.843v.005zm-4.146 21.082a1.093 1.093 0 110-2.187h10.539a2.473 2.473 0 002.24-2.461c0-1.275-.972-2.341-2.24-2.461H31.93v-2.188h14.274a4.657 4.657 0 014.34 4.649 4.657 4.657 0 01-4.34 4.648H35.666z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.627 47.562h-6.333a4.287 4.287 0 110-8.575h9.429a1.093 1.093 0 110 2.187h-9.428a2.1 2.1 0 000 4.2h6.332a1.093 1.093 0 110 2.188z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.922 53.353h-6.178v-2.187h6.178a1.802 1.802 0 100-3.604h-5.83a1.093 1.093 0 110-2.188h5.83a3.989 3.989 0 110 7.98z"
})));

var SvgEms = function SvgEms(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 80,
    viewBox: "0 0 82 80"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/ems.56e0fc5f.svg";
export { SvgEms as ReactComponent };